// Framework-independent utilities shared by the application and public pages.
export const env = process.env.NODE_ENV

export const isDevEnv = env === "development" || env === "dev" || env === "staging"
export const isProdEnv = env === "production" || env === "prod"


export function delay(timeout = 0, data) {
	return new Promise(resolve => {
		setTimeout(resolve.bind(null, data), timeout)
	});
}

export function asBase64(str){
	console.log("asBase64: str = ", str)
	try{
		return btoa(str)
	} catch (e) {
		console.warn("asBase64: error = ", e)
		return btoa(encodeURIComponent(str))
	}

}
